import React from 'react';
import {NotificationCenterButton} from './components/NotificationCenterButton';

export const NotificationCenterButtonShell: React.FC<{
  notificationBellRef: React.RefObject<HTMLDivElement>;
}> = ({notificationBellRef}) => {
  return (
    <NotificationCenterButton
      notifications={[]}
      notificationBellRef={notificationBellRef}
      onClick={() => void 0}
    />
  );
};
